import React from 'react';
import './PC.css';
import Geckoboard from '../../img/pc2/Geckoboard.png'
import Lew from '../../img/pc2/Lew.png'
import Tester from '../../img/pc2/Tester.png'
import XBOSoft from '../../img/pc2/XBOSoft.png'
import Denoo from '../../img/pc2/Denoo.png'
import ISTQB from '../../img/pc2/ISTQB.png'
import Marcetic from '../../img/pc2/Marcetic.png'
import TarabaTech from '../../img/pc2/TarabaTech.png'
import Ragavan from '../../img/pc2/Ragavan.png'
import Sacco from '../../img/pc2/Sacco.png'
import TravelX from '../../img/pc2/TravelX.png'
import Wright from '../../img/pc2/Wright.png'
import VivitWorldwide from '../../img/pc2/VivitWorldwide.png'
import Dijkstra from '../../img/pc2/Dijkstra.png'
import OnTestAutomation from '../../img/pc2/OnTestAutomation.png'
import Charlton from '../../img/pc2/Charlton.png'
import Functionize from '../../img/pc2/Functionize.png'
import Rusinchuk from '../../img/pc2/Rusinchuk.png'
import CUCollaborate from '../../img/pc2/CUCollaborate.png'

export default class PC extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      speakers: [
        {
          photo: Lew,
          name: 'Philip Lew',
          position: 'CEO',
          ln: 'https://www.linkedin.com/in/philiplew/',
          tw: 'https://twitter.com/philiplew',
          tw2: 'https://twitter.com/xbosoft',
          logo: XBOSoft,
        },
        {
          photo: Tester,
          name: 'Mike Harris',
          position: 'Tester',
          ln: 'https://www.linkedin.com/in/mike-harris-citp-mbcs-5a75733/',
          website: 'https://testandanalysis.home.blog/',
          website2: 'https://mastodonapp.uk/@TestAndAnalysis',
          logo: Geckoboard,
        },
        {
          photo: Denoo,
          name: 'Olivier Denoo',
          position: 'Président',
          ln: 'https://www.linkedin.com/in/olivier-denoo-2884a5/',
          logo: ISTQB,
        },
        {
          photo: Marcetic,
          name: 'Minja Marcetic',
          position: 'Head of Quality Assurance',
          ln: 'https://www.linkedin.com/in/minja-marcetic/',
          logo: TarabaTech,
        },
        {
          photo: Ragavan,
          name: 'Ambighananthan Ragavan',
          position: 'Principal Software Engineer',
          ln: 'https://www.linkedin.com/in/aragavan/',
          website: 'https://medium.com/@eelam.ragavan',
          github: 'https://github.com/ambirag',
        },
        {
          photo: Sacco,
          name: 'Andres Sacco',
          position: 'Technical Leader',
          ln: 'https://www.linkedin.com/in/saccoandres/',
          tw: 'https://twitter.com/adsChosen',
          github: 'https://github.com/andres-sacco',
          logo: TravelX,
        },
        {
          photo: Wright,
          name: 'Jonathon Wright',
          position: 'CTO',
          ln: 'http://linkedin.com/in/automation',
          logo: VivitWorldwide,
        },
        {
          photo: Dijkstra,
          name: 'Bas Dijkstra',
          position: 'Test automation trainer and consultant',
          ln: 'https://www.linkedin.com/in/basdijkstra/',
          github: 'https://github.com/basdijkstra',
          logo: OnTestAutomation,
        },
        {
          photo: Charlton,
          name: 'Jenna Charlton',
          position: 'Director of Product',
          ln: 'https://www.linkedin.com/in/jbcharlton/',
          tw: 'https://twitter.com/theywrestletest',
          logo: Functionize,
        },
        {
          photo: Rusinchuk,
          name: 'Sergii Rusinchuk',
          position: 'QA Manager',
          ln: 'https://www.linkedin.com/in/sergii-rusinchuk-554525192/',
          website: 'https://www.rusinchuk.com/',
          logo: CUCollaborate,
        },
      ],
    }
  }

  renderPC(item, i) {
    return (
      <div className="pc_item" key={`team-${i}`}>
        <div className='pc_info' style={{ backgroundImage: `url(${item.photo}` }}>
          <p className="pc_name p1">{item.name}</p>
          <p className="pc_position p2 grey">{item.position}</p>
          <img className='pc_logo' src={item.logo} alt="" />
          <div className="pc_links">
            {item.fb && <a className="social_link social_fb" target='_blank' rel="noreferrer" href={item.fb}></a>}
            {item.ln && <a className="social_link social_ln" target='_blank' rel="noreferrer" href={item.ln}></a>}
            {item.tw && <a className="social_link social_tw" target='_blank' rel="noreferrer" href={item.tw}></a>}
            {item.tw2 && <a className="social_link social_tw" target='_blank' rel="noreferrer" href={item.tw2}></a>}
            {item.github && <a className="social_link social_github" target='_blank' rel="noreferrer" href={item.github}></a>}
            {item.website && <a className="social_link social_website" target='_blank' rel="noreferrer" href={item.website}></a>}
            {item.website2 && <a className="social_link social_website" target='_blank' rel="noreferrer" href={item.website2}></a>}
            {item.youtube && <a className="social_link social_yb" target='_blank' rel="noreferrer" href={item.youtube}></a>}
            {item.twitch && <a className="social_link social_twitch" target='_blank' rel="noreferrer" href={item.twitch}></a>}
          </div>
        </div>
      </div>
    )
  }

  render() {
    return (
      <div className="pc_wrap pc_wrap--mb" id='pc'>
        <div className='container pc'>
          <h2 className='pc_title pc_main'>Program committee</h2>
          <div className='pc_block'>
            {this.state.speakers.map((item, i) => this.renderPC(item, i))}
          </div>
        </div>
      </div>
    )
  }
}